import React from 'react';
import { Flex, Icon, Tag, Text } from 'core/components';

interface VariableTagProps {
  name: string;
  icon?: string | null;
  iconColor?: string;
  asTag?: boolean;
}

export default function VariableTag({ name, icon = 'variable', iconColor = 'purple', asTag = true }: VariableTagProps) {
  if (!asTag) {
    return (
      <Flex alignItems="center" gap="4px">
        {icon != null && <Icon icon={icon} color={iconColor} iconSize={12} />}
        <Text>{name}</Text>
      </Flex>
    );
  }

  return (
    <Tag round>
      <Flex alignItems="center" gap="4px">
        {icon != null && <Icon icon={icon} color={iconColor} iconSize={12} />}
        <Text>{name}</Text>
      </Flex>
    </Tag>
  );
}
